import { CheckOutlined } from '@ant-design/icons';
import styles from './aiSwitch.module.less';
import { Switch } from 'antd';

type AiSwitchProps = {
    checked: boolean;
    onChange: (checked: boolean) => void;
    defaultChecked?: boolean;
    disabled?: boolean;
    size?: 'small' | 'default';
    loading?: boolean;
};

/**
 * Switch for toggling on/off Ai features
 * @param checked
 * @param onChange
 * @param defaultChecked
 * @param disabled
 * @param size
 * @param loading
 * @param rest
 * @constructor
 */
export function AiSwitch({
    checked,
    onChange,
    defaultChecked = false,
    disabled = false,
    size = 'default',
    loading = false,
    ...rest
}: AiSwitchProps) {
    return (
        <div className={styles.aiSwitch}>
            <Switch
                {...rest}
                checked={checked}
                defaultChecked={defaultChecked}
                disabled={disabled}
                onChange={onChange}
                size={size}
                loading={loading}
                checkedChildren={<CheckOutlined />}
            />
        </div>
    );
}
